import { render, staticRenderFns } from "./emr.vue?vue&type=template&id=58206058"
import script from "./emr.vue?vue&type=script&lang=js"
export * from "./emr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports